import { api } from "utils/api";

/**
 * Async API call for wallet signature authentication
 */
const postWalletAuth = (walletAddress: string, signature: string) => {
  const options = {
    method: "POST",
    body: JSON.stringify({ walletAddress, signature }),
  };
  return api("/auth/wallet", options);
};

export { postWalletAuth };
